import { Box } from '@mui/material';

function DayContentContainer({ children }) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        gap: 0.7,
        mt: 0.5,
        minHeight: 0,
        px: 0.5,
      }}>
      {children}
    </Box>
  );
}

export default DayContentContainer;
